const entitysType = {
    event: "event",
    course: "course",
    assessment: "assessment",
    usefulTool: "usefulTool",
    shourtcut: "shourtcut",
    studyGroup: "studyGroup",
    message: "message",
    counter: "counter",
    board: "board",
    bot: "bot",
    applet: "applet",
}

export default entitysType;